import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { AppIcon, IconClock, IconKit, IconPencil, IconQr, IconSend, IconUser, IconWrench, type IconProps } from "@wilco/ui";
import type { ComponentType } from "react";
import { formatNumber, t } from "../i18n.ts";
import { employeesQuery, expensesQuery } from "./queries.ts";

/** Раздел «Кадри»: экраны плитками, как на столе. */
export function HrHub() {
  const employees = useQuery(employeesQuery);
  const expenses = useQuery(expensesQuery);
  const active = employees.data ? employees.data.filter((e) => !e.archived).length : null;
  const drafts = expenses.data ? expenses.data.filter((e) => e.state === "draft").length : null;
  return (
    <div className="page">
      <h1 className="page-title page-title-icon">
        <AppIcon name="hr" size={32} />
        {t("section.hr")}
      </h1>
      <div className="tiles">
        <Link to="/hr/employees" className="tile w-cut">
          <TileBody icon={IconUser} count={active} title={t("people.employees")} />
        </Link>
        <Link to="/attendance" className="tile w-cut">
          <TileBody icon={IconClock} count={null} title={t("section.attendance")} />
        </Link>
        <Link to="/hr/leave" className="tile w-cut">
          <TileBody icon={IconSend} count={null} title={t("leave.title")} />
        </Link>
        <Link to="/hr/expenses" className="tile w-cut">
          <TileBody icon={IconPencil} count={drafts} title={t("exp.title")} />
        </Link>
        <Link to="/hr/doors" className="tile w-cut">
          <TileBody icon={IconKit} count={null} title={t("doors.title")} />
        </Link>
        <Link to="/hr/terminals" className="tile w-cut">
          <TileBody icon={IconWrench} count={null} title={t("term.title")} />
        </Link>
        <Link to="/kiosk" className="tile w-cut">
          <TileBody icon={IconQr} count={null} title={t("kiosk.title")} />
        </Link>
      </div>
    </div>
  );
}

function TileBody({ icon: Icon, count, title }: { icon: ComponentType<IconProps>; count: number | null; title: string }) {
  return (
    <>
      {count === null ? (
        <Icon className="tile-glyph" />
      ) : (
        <>
          <Icon className="tile-icon" />
          <span className="tile-count w-num">{formatNumber(count)}</span>
        </>
      )}
      <span className="tile-title">{title}</span>
    </>
  );
}
